import StarsBackground from "./StarsBackground";
import TypewriterText from "./TypewriterText";
import ProfileImage from "./ProfileImage";
import ScrollIndicator from "./ScrollIndicator";
import { motion } from "framer-motion";

const Hero = () => {
  return (
    <section
      id="home"
      className="relative flex flex-col md:flex-row items-center justify-between px-8 sm:px-16 py-24 bg-gradient-to-r from-blue-900 via-purple-800 to-blue-600 min-h-screen text-white overflow-hidden"
    >
      {/* Animated Background Particles */}
      <StarsBackground />

      {/* Left Side Text */}
      <div className="flex-1 text-center md:text-left space-y-4">
        <p className="text-lg sm:text-xl">Hello, I’m Nachiketa,</p>
        <TypewriterText />
        <p className="mt-4 text-lg sm:text-xl">based in Los Angeles, CA.</p>
        <motion.button
          whileHover={{ scale: 1.1 }}
          className="mt-6 px-6 sm:px-8 py-3 bg-yellow-400 text-blue-900 font-bold rounded-lg shadow-lg hover:bg-yellow-500 transition"
          onClick={() => window.open("/Nachiketa_Kumar_Resume.pdf", "_blank")}
        >
          Resume
        </motion.button>
      </div>

      {/* Right Side Profile Image */}
      <div className="flex-1 flex justify-center mt-10 md:mt-0">
        <ProfileImage />
      </div>

      {/* Scroll Down Indicator */}
      <ScrollIndicator />
    </section>
  );
};

export default Hero;